import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  modal: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    borderWidth: 0,
  },
  container: {
    flex: 1,
    backgroundColor: '#000',
    opacity: 0.1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalBox: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    justifyContent: 'center',
  },
  modalContentLarge: {
    backgroundColor: '#fff',
    width: '30%',
    height: '45%',
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 30,
  },
  modalContentSmall: {
    backgroundColor: '#fff',
    width: '90%',
    height: '35%',
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 30,
  },
  modaIconContainer: {
    position: 'absolute',
    top: -30,
    zIndex: 100,
    borderRadius: 35,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 5,
    width: 70,
    height: 70,
  },
  iconContainer: {
    flex: 1,
    justifyContent: 'center',
    padding: 5,
  },
  modalTextTitle: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
  },
  modalTextMessage: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 20,
    letterSpacing: 0.25,
  },
  modalTextContainerTitle: {
    flex: 0.2,
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: 10,
  },
  modalTextContainerMessage: {
    flex: 0.3,
    alignSelf: 'center',
    justifyContent: 'center',
    marginBottom: 10,
  },
  modalBtnContainer: {
    flex: 0.3,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  btnContainerStyle: {
    flex: 0.8,
  },
  confirmBtnStyle: {
    backgroundColor: '#FFFFFF',
    height: '65%',
  },
  confirmBtnStyleSmall: {
    backgroundColor: '#FFFFFF',
    height: '100%',
  },
  confirmBtnText: {
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 16,
    letterSpacing: 1.25,
    textAlign: 'center',
  },
});
